import { useParams } from 'react-router';

import { ScenarioRoutePaths } from '@app-velocity/modules/scenarios';

import { ConfigureScenario } from '../ConfigureScenario';
import { ConfigureScenarioContext } from '../context/ConfigureScenarioContext';

export const ConfigureScenarioAuth = () => {
  const { workspaceId, teamId } = useParams<{
    teamId: string;
    workspaceId: string;
  }>();

  if (!workspaceId || !teamId) return null;

  return (
    <ConfigureScenarioContext.Provider
      value={{
        mode: 'authorized',
        workspaceId,
        teamId,
        challengeAFlow: ScenarioRoutePaths.challengeAFlow,
        challengeSimulation: ScenarioRoutePaths.challengeSimulation,
      }}
    >
      <ConfigureScenario />
    </ConfigureScenarioContext.Provider>
  );
};
